import { render, staticRenderFns } from "./sales-by-product-specific-type.vue?vue&type=template&id=e048ea9e&scoped=true&"
import script from "./sales-by-product-specific-type.vue?vue&type=script&lang=js&"
export * from "./sales-by-product-specific-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e048ea9e",
  null
  
)

export default component.exports